import React, { useRef } from 'react';
import LabelAction from '@meitu/saas-editor-ui/es/components/label-action';
import { useGlobalWidget } from '@meitu/saas-editor-ui/es/hooks/use-global-widget';
import { ColorGroup } from '@meitu/xdesign-widgets';
import { useLocaleStore } from '@/i18n';
import { editor } from '@/instance';

export const FillFeature: React.FC<{
    id: string;
    fill: string;
}> = React.memo(({ id, fill }) => {
    const { $t } = useLocaleStore();
    const originVal = useRef<string | null>(null);
    const cacheId = useRef(id);
    const globalWidgetRef = useGlobalWidget(editor, false);

    return (
        <div className="c-qrcode-panel__item">
            <LabelAction title={$t((v) => v.panel.qrCodePanel.backgroundColor)} align={true}>
                <ColorGroup
                    onOpenChange={(e) => {
                        globalWidgetRef.current = e;
                    }}
                    popupTriggerSize={{
                        width: 52,
                        height: 26,
                    }}
                    showIcon={false}
                    color={fill}
                    setColor={(val) => {
                        cacheId.current = id;
                        if (originVal.current === null) {
                            originVal.current = fill;
                        }
                        editor.qrCodeLayer.updateStyle(id, { fill: val });
                    }}
                    setColorAfter={(val, __, { isBrandColor }) => {
                        if (isBrandColor) {
                            window._stat_track?.('hb_layers_func_use', {
                                func_id: '5_107',
                            });
                        }
                        if (originVal.current) {
                            editor.qrCodeLayer.updateStyle(
                                cacheId.current || id,
                                { fill: val },
                                { writeHistory: true, oldStyle: { fill: originVal.current } },
                            );
                        }
                        originVal.current = null;
                    }}
                    isGradient={false}
                    popupOverlayClassName="c-qrcode-panel__color-picker"
                    onToggleBizTab={(bizTab) => {
                        if (bizTab === 'team') {
                            window._stat_track?.('hb_layers_func_click', {
                                func_id: '5_107',
                            });
                        }
                    }}
                />
            </LabelAction>
        </div>
    );
});
